import ParkHome from '@/pages/parks/ParkHome'
import Parks from '@/pages/parks/Parks'
import CreatePark from '@/pages/parks/CreatePark'
import EditPark from '@/pages/parks/EditPark'
import GeneralInformations from '@/pages/quizzes/GeneralInformations'
import ParkQuiz from '@/pages/quizzes/ParkQuiz'

const routes = [
  {
    path: '/park',
    name: 'ParkHome',
    component: ParkHome,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK']
    }
  },
  {
    path: '/general-informations/:parkId',
    name: 'GeneralInformations',
    component: GeneralInformations,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole() || authentication.userHasAdminRole()) {
            resolve()
            return
          }
          if (to.params.parkId !== authentication.getParkId()) {
            router.push({name: 'UnauthorizedError'})
          }
          resolve()
        })
      }
    },
    props: true
  },
  {
    path: '/park-quiz/:parkId/:referenceYear/:quizUuid?',
    name: 'ParkQuiz',
    component: ParkQuiz,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK']
    },
    props: true
  },
  {
    path: '/parks',
    name: 'Parks',
    component: Parks,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/create-park',
    name: 'CreatePark',
    component: CreatePark,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/edit-park/:id',
    name: 'EditPark',
    component: EditPark,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole() || authentication.userHasAdminRole()) {
            resolve()
            return
          }
          if (to.params.id !== authentication.getParkId()) {
            router.push({name: 'UnauthorizedError'})
          }
          resolve()
        })
      }
    },
    props: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/parks.js